import React,{useState} from 'react'
import {  Button,Form,Select } from 'semantic-ui-react'
import CSS from './Register.module.css';
import {Avatar,Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {registerVendor,signOut} from '../../Store/Action';
import { connect } from 'react-redux';
import Message from './Message';
import { withRouter } from 'react-router-dom';
import Errormsg from './Errormsg';
import TandC from './TandC';

const useStyles = makeStyles((theme) => ({
    large: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      margin : 'auto auto',
    },
  }));


function Register(props) {
        
    const classes = useStyles();

    const options=[
        { key : '0',value : 'a',text: 'CA and Accounting' },
        { key : '1',value : 'b',text: 'Data Science' },
        { key : '2',value : 'c',text: 'Designing and Drafting' },
        { key : '3',value : 'd',text: 'Digital Marketing' },
        { key : '4',value : 'e',text: 'Engineering' },
        { key : '5',value : 'f',text: 'Event Management' },
        { key : '6',value : 'g',text: 'Food and Catering' },
        { key : '7',value : 'h',text: 'Freelancing' },
        { key : '8',value : 'i',text: 'Graphic Designing' },
        { key : '9',value : 'j',text: 'Human Resources'},
        { key : '10',value : 'k',text: 'Interior Designing'},
        { key : '11',value : 'l',text: 'Machining'},
        { key : '12',value : 'm',text: 'Production Man Power'},
        { key : '15',value : 'p',text: 'Printing'},
        { key : '13',value : 'n',text: 'Tools and Materials'},
        { key : '14',value : 'o',text: 'Web Development'},
        { key : '16',value : 'q',text: 'Others'},
    ]

 
    
    const initialState={
        cName : '',
        fullName : '',
        service : '',
        address : '',
        number : '',
        email : '',
        desc : ''
    }
    const [state, setstate] = useState(initialState)

    const [agreed, setagreed] = useState()

    const [showMessage, setshowMessage] = useState(false)

    const getDets=(e)=>{
        setstate(prevState=>({...prevState , [e.target.name] : e.target.value}))
    }
     const getService=(e)=>{
         setstate(prevState=>({...prevState,service : e.target.textContent}))
     }

    const onSubmitForm=()=>{
        if((state.cName,state.fullName,state.service,state.address,state.number === '' )){
            setshowMessage(true)
            setTimeout(() => {
                setshowMessage(false)
            }, 4000);
            return setstate(prevState=>({ ...prevState, error : "All Field must be Filled" }))
        }

        props.register(state,props.history,state.service)
        setstate({ cName : '',desc : '',fullName : '',service : '',address : '',number : '',email : '',error : ''})
        setshowMessage(true)
            setTimeout(() => {
                setshowMessage(false)
            }, 4000);
    }

    const agreedSuccess=()=>{
        setagreed(!agreed)
    }

    const Back=()=>{
        props.logout(props.history)
    }

    return (
        <div className={`${CSS.form} mt-5 mb-5 container `}>
            <div className={`${CSS.segment} bg-light`} >
            <Typography color="textSecondary" align="center" variant="h4" >
                Vendor Registration
            </Typography>
            <Avatar alt="logo" src="../../../Free192.png" style={{border :'1px solid #999',margin:'2rem auto'  }} className={classes.large} />
            <Form >
                <Form.Field required className={CSS.inputs}>
                    <label>Company Name</label>
                    <input value={state.cName} onChange={getDets} name="cName"  placeholder='Company Name' />
                </Form.Field>
                <Form.Field required className={CSS.inputs}>
                    <label>Full name</label>
                    <input value={state.fullName} onChange={getDets} name="fullName" placeholder='Full name' />
                </Form.Field> 
                <Form.Field required className={CSS.inputs}>
                    <label>Email</label>
                    <input value={state.email} onChange={getDets} name="email" placeholder='johndoe@gmail.com' />
                </Form.Field> 
                <Form.Field required className={CSS.inputs}>
                <label>Choose your service</label>
                <Select  onChange={getService} options={options} placeholder="Select Service"   />
                </Form.Field>
                <Form.Field required className={CSS.inputs}>
                    <label>Address</label>
                    <input value={state.address} onChange={getDets} name="address" placeholder='Address' />
                </Form.Field>
                <Form.Field className={CSS.inputs}>
                    <label>Description</label>
                    <input value={state.desc} onChange={getDets} name="desc" type="text" placeholder='Service description' />
                </Form.Field>
                <Form.Field required className={CSS.inputs}>
                    <label>Contact Number</label>
                    <input value={state.number} onChange={getDets} name="number" type="text" placeholder='Contact Number' />
                </Form.Field>
                <Form.Field required align="center" className="mt-4 mb-4" >
                    <TandC agreeValue={agreed} agreeMethod={agreedSuccess} />
                </Form.Field>
                <div className="text-center mt-2">
                <Button onClick={Back} inverted color="grey" size="small" style={{color : "grey",marginRight : '1rem' }}>Back</Button>
                {
                    agreed ? 
                    <Button onClick={onSubmitForm} inverted  size="small" color="green" type='submit'>Register</Button>
                    :
                    <Button disabled inverted  size="small" color="green" type='submit'>Register</Button>
                }
                </div>
            </Form>
            { (state.error) ? 
            <Errormsg open={showMessage} msg={state.error}/>
            :
            <Message open={showMessage} />
            }
            </div>
        </div >
    )
}

const mapStateToProps=state=>({
    state_data  : state.reducer
})

const mapDispatchToProps=({
    register : registerVendor,
    logout : signOut
})
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Register))
